import React from "react";
import { PracticeMobileModalIcon } from "components/atoms/Icon";
import { Typography, Button } from "components/atoms";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  type: "online" | "bubble";
  description: string;
  btnLabel: string;
  pdfUrl?: string;
  launchUrl?: string;
  onlineProctor_1?: string;
  onlineProctor_2?: string;
  onlineProctor_3?: string;
  isPdfUrl?: boolean;
}

export const PracticeMobileModalInnerCard = ({
  theme,
  type,
  description,
  btnLabel,
  launchUrl,
  pdfUrl,
  onlineProctor_1,
  onlineProctor_2,
  onlineProctor_3,
  isPdfUrl,
}: IProps) => {
  const handlePrimaryBtnClick = () => {
    if (launchUrl) {
      window.open(launchUrl, "__blank");
    }
  };

  const handlePdfBtnClick = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "__blank");
    }
  };

  return (
    <div className="practice-mobile-modal-inner-card-wrapper">
      <div className="icon-section">
        <PracticeMobileModalIcon theme={theme} type={type} />
      </div>
      <div className="title-section">
        <Typography
          label={type === "online" ? "Online" : "Bubblesheet"}
          variant="h1Bold"
          styles="title-typography-custom-style"
        />
      </div>
      <div className="description-section">
        <Typography label={description} variant="h8Med" />
      </div>
      <div className="btn-section">
        <Button
          label={btnLabel}
          icon={false}
          type="score"
          onClick={handlePrimaryBtnClick}
        />
        {isPdfUrl ? (
          <Button
            label="Download Exam PDF"
            icon={false}
            type="online"
            onClick={handlePdfBtnClick}
          />
        ) : null}
      </div>
      {onlineProctor_1 || onlineProctor_2 || onlineProctor_3 ? (
        <div className="proctor-section">
          {onlineProctor_1 ? (
            <div className="proctor_1">
              <Typography
                label="Online Proctor"
                variant="h9Bold"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
          {onlineProctor_2 ? (
            <div className="proctor_2">
              <Typography
                label="Online Proctor 1.5x Timer"
                variant="h9Bold"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
          {onlineProctor_3 ? (
            <div className="proctor_3">
              <Typography
                label="Online Proctor 2x Timer"
                variant="h9Bold"
                styles="custom-proctor-typography-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
